import React from 'react'
import { Tabs, Divider, Statistic } from 'antd'

import './Graph.css'

const { TabPane } = Tabs

const StatisticTab = props => {
    const extraStyle = props.active ? { backgroundColor: '#e6faff', borderRight: '2px solid #038fde' } : {}

    return (
        <div onClick={props.onClick}>
            <Statistic
                title={props.title}
                value={props.value}
                style={{ ...{ padding: 12 }, ...extraStyle }}
                className="item-menu-graph"
            />
        </div>
    )
}

const TabPaneGraph = ({ tab, key, values, active, onChange }) => {
    const { messages, users, connections } = values

    return (
        <TabPane tab={tab} key={key}>
            <StatisticTab
                title="Messages"
                value={messages}
                active={active === 'messages'}
                onClick={() => {
                    onChange('messages')
                }}
            />
            <Divider style={{ margin: 0 }} />
            <StatisticTab
                title="Users"
                value={users}
                active={active === 'users'}
                onClick={() => {
                    onChange('users')
                }}
            />
            <Divider style={{ margin: 0 }} />
            <StatisticTab
                title="Peak Concurrent Connections"
                value={connections}
                active={active === 'connections'}
                onClick={() => {
                    onChange('connections')
                }}
            />
        </TabPane>
    )
}

class MenuGraph extends React.Component {
    changeTab(period) {
        this.props.onChange({ ...this.props.state, period })
    }

    changeRessource(ressource) {
        this.props.onChange({ ...this.props.state, ressource })
    }

    render() {
        const { state } = this.props
        const { ressource, period } = state

        const { usersCounter, connectionsCounter, messagesCounter } = this.props

        return (
            <Tabs
                defaultActiveKey={period}
                tabBarStyle={{ margin: 0 }}
                style={{ cursor: 'pointer' }}
                onChange={key => this.changeTab(key)}
            >
                {TabPaneGraph({
                    tab: 'Daily',
                    key: 'daily',
                    values: {
                        messages: messagesCounter.today,
                        users: usersCounter.today,
                        connections: connectionsCounter.today
                    },
                    active: ressource,
                    onChange: value => this.changeRessource(value)
                })}
                {TabPaneGraph({
                    tab: 'Monthly',
                    key: 'monthly',
                    values: {
                        messages: messagesCounter.this_month,
                        users: usersCounter.this_month,
                        connections: connectionsCounter.this_month
                    },
                    active: ressource,
                    onChange: value => this.changeRessource(value)
                })}
            </Tabs>
        )
    }
}

export default MenuGraph
